<app-header selected="plans"></app-header>

<div class="h-100 overflow-auto" style="padding-bottom:80px">
  <div class="container plns">
    <h2>Our Plans</h2>    
    <p>We have a selection of affordable plans for students of various socioeconomic backgrounds to<br> be able to afford our app all while simplifying their scholarship search.</p>
</div>
<div class="container mnthly-btnz">
    <button class="mnth">MONTHLY</button><button class="yrly">ANNUALLY</button>
</div>

<section class="pricing py-5">
  <div class="container">
    <div class="row">
      <!-- Free Tier -->
      <div class="col-lg-4 grow1">
        <div class="card mb-5 mb-lg-0">
          <div class="card-body">
            <h5 class="card-title text-muted text-uppercase text-center">Grow PLAN</h5>
            <h6 class="card-price text-center">$0</h6>
            <span class="blw-price">Always</span>
            <p>Our Free plan is for student who simply<br>needs to get started</p>
            <hr>
            <ul class="fa-ul">
              <li><span class="fa-li"><img class="chkz" src="../../assets/images/tick.svg"></span>Three(3) scholorship applications per month</li>
              <li><span class="fa-li"><img class="chkz" src="../../assets/images/tick.svg"></span>Scholorship resources</li>
              
            </ul>
            <div class="d-grid">
              <a href="#" class="btn sbs-btn">Subscribe Now</a>
            </div>
          </div>
        </div>
      </div>
      <!-- Plus Tier -->
      <div class="col-lg-4">
        <div class="card crd2 mb-5 mb-lg-0 card_disabled">
          <div class="card-body">
            <h5 class="card-title text-muted text-uppercase text-center">Excel Plan</h5>
            <h6 class="card-price text-center">$6</h6>
            <span class="blw-price">Per month - OR - $47 billed<br> annually</span>
            <p class="exl-p">Excel plan is for the student who desires to<br> take their scholarship search up a notch:</p>
            <hr>
            <ul class="fa-ul">
              <li><span class="fa-li"><img class="chkz" src="../../assets/images/tick.svg"></span>Seven(7) scholarship<br>applications per month</li>
              <li><span class="fa-li"><img class="chkz" src="../../assets/images/tick.svg"></span>Access to scholarship database</li>
              <li><span class="fa-li"><img class="chkz" src="../../assets/images/tick.svg"></span>Scholarship resources</li>
              
            </ul>
            <div class="d-grid">
              <a class="btn sbs-btn sb2">Subscribe Now</a>
            </div>
          </div>
        </div>
      </div>
      <!-- Pro Tier -->
      <div class="col-lg-4">
        <div class="card card_disabled">
          <div class="card-body">
            <h5 class="card-title text-muted text-uppercase text-center">Catapult Plan</h5>
            <h6 class="card-price text-center">$10</h6>
            <span class="blw-price">Per month - OR - $67 billed<br> annually</span>
            <p class="exl-p">Catapult plan is for the student who wants<br>the complete bells and whistles:</p>
            <hr>
            <ul class="fa-ul">
              <li><span class="fa-li"><img class="chkz" src="../../assets/images/tick.svg"></span>Ten(10) scholarship<br>applications per month</li>
              <li><span class="fa-li"><img class="chkz" src="../../assets/images/tick.svg"></span>Access to scholarship database</li>
              <li><span class="fa-li"><img class="chkz" src="../../assets/images/tick.svg"></span>Notification of new scholarship</li>
              <li><span class="fa-li"><img class="chkz" src="../../assets/images/tick.svg"></span>Scholarship resources</li>
              
            </ul>
            <div class="d-grid">
              <a  class="btn sbs-btn sb3">Subscribe Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- 
<section>
  <div class="container stdnts">
    <div class="col-lg-12 std">
      <h2>What Our Students Have To<br> Say About Us</h2>
    </div>
  </div>
  <div>
    <div class="container modest">
      <div class="qte-img"><img src="../../assets/images/left-quote.png"></div>
      <div class="col-lg-4 fst">
        <p class="ptxt">Tum dicere exorsus est consecutus? laudem et expedita distinctio nam libero tempore, cum memoriter, tum etiam erga nos causae confidere, sed quia non numquam eius modi tempora incidunt, ut perspiciatis, unde omnis iste natus error sit numeranda nec segniorem ad id totum evertitur eo delectu.</p>
        <div class="sldr-pc">
          <h4>Afonso Pinto</h4>
          <p>Sed ut ratione voluptatem et dolore <br>magnam aliquam causam ista.</p>
          <div class="icnz"><img class="l-icn" src="../../assets/images/icn-l.png"><img class="r-icn" src="../../assets/images/icn-r.png"></div>
        </div>
      </div>
      <div class="col-lg-4 scnd">
        <img class="rec1" src="../../assets/images/Rectangle.png">
      </div>
    </div>
  </div>
  
</section> -->
</div>
